import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CodeModel } from '../common-code/CommonCode';
import { withSetPropAction } from '../extensions/withSetPropAction';
import { OperatorInfo } from '../operator-info/OperatorInfo';

/**
 * # Menu
 *
 * Menu을 설명하세요.
 */
export const Menu = types
  .model('Menu')
  .props({
    menuSid: types.optional(types.maybeNull(types.number), 0), // 메뉴ID
    menuNm: types.optional(types.maybeNull(types.string), ''), // 메뉴명
    menuUri: types.optional(types.maybeNull(types.string), ''), // 메뉴URI
    menuPsid: types.optional(types.maybeNull(types.number), 0), // 메뉴부모일련ID
    ordr: types.optional(types.maybeNull(types.number), 0), // 메뉴순서
    dscrpt: types.optional(types.maybeNull(types.string), ''), // 설명
    menuTypeCd: types.maybeNull(CodeModel), // 메뉴유형코드
    useYn: types.optional(types.maybeNull(types.boolean), false), // 사용여부
    regUser: types.maybeNull(OperatorInfo), // 등록ID
    regDt: types.optional(types.maybeNull(types.string), ''), // 등록일시
    regId: types.maybeNull(types.number), // 등록ID
    updId: types.maybeNull(OperatorInfo), // 수정ID
    updDt: types.optional(types.maybeNull(types.string), ''), // 수정일시
    menuSidList: types.optional(types.maybeNull(types.array(types.number)), []),
    oprtrGroupSid: types.optional(types.maybeNull(types.number), 0), // 사용자 그룹 일련 ID
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TMenu = Instance<typeof Menu>;
type TMenuSnapshot = SnapshotOut<typeof Menu>;

export interface IMenu extends TMenu {}
export type TMenuKeys = keyof TMenuSnapshot & string;
export interface IMenuSnapshot extends TMenuSnapshot {}
export const createMenu = () => types.optional(Menu, {} as TMenu);
